<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title v-if="!typeProp" class="mt-4 me-4"> {{ $t($route.name) }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile && type !== 'removedInvoices' && $store.state.permissions && $store.state.permissions.includes('remove' + type[0].toUpperCase() + type.substring(1))"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="$store.state.permissions && $store.state.permissions.includes('importExcelInvoice')"
            link
            @click="openUploadDialog"
          >
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0 && lockPermission"
            link
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <v-list-item
            v-if="type !== 'removedInvoices'"
            :disabled="(!selected || selected && selected.length === 0 ? true : false)"
            link
            @click="groupPrintDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-settings</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('groupPrint')" />
          </v-list-item>
          <v-list-item
            v-show="type === 'sell' && $store.state.permissions && $store.state.permissions.includes('reviewDigikalaOrder') && $store.state.digikala == 'active'"
            :disabled="(!selected || selected && selected.length === 0 ? true : false)"
            link
            @click="reviewDigikalaOrder"
          >
            <v-list-item-icon>
              <v-icon>mdi-shopping-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('reviewDigikalaOrder')" />
          </v-list-item>
          <v-list-item
            v-show="type === 'removedInvoices'"
            :disabled="(!selected || selected && selected.length === 0 ? true : false)"
            link
            @click="refreshRemovedItem"
          >
            <v-list-item-icon>
              <v-icon>mdi-delete-restore</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refreshRemovedItem')" />
          </v-list-item>
          <v-list-item
            v-show="$route.name === 'sellTaxPayer' && $store.state.allConfig && $store.state.allConfig.taxPayerSystem && $store.state.allConfig.taxPayerSystem == 'active'"
            :disabled="(!selected || selected && selected.length === 0 ? true : false)"
            link
            @click="sendTaxInvoice('review')"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-document-refresh-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('reviewInvoices')" />
          </v-list-item>
          <v-list-item
            v-show="(type === 'sell' || type === 'returnSell') && $store.state.permissions && $store.state.permissions.includes('sendTaxPayer') && $store.state.allConfig && $store.state.allConfig.taxPayerSystem && $store.state.allConfig.taxPayerSystem == 'active'"
            :disabled="(!selected || selected && selected.length === 0 ? true : false)"
            link
            @click="sendTaxInvoice"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-document-arrow-right-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('sendTaxInvoice')" />
          </v-list-item>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="(isMobile || isTablet) && type !== 'removedInvoices'"
            link
            @getAllRows="getAllRows"
          >
          <export-excel
            ref="refExcel"
            :data="excelItems"
            worksheet="abriron.com"
            name="data.xls"
            type="xls"
            class="float-left d-flex"
            :title="$store.state.abrName"
            :total-prop="pageCount"
            :page-prop="excelPage"
            @getAllRows="getAllRows"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excel')" />
          </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="(isMobile || isTablet) && $route.name !== 'sellTaxPayer' && $store.state.permissions && $store.state.permissions.includes(type)"
            link
            @click="goTo(type)"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet && type !== 'removedInvoices'"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn
          outlined
          class="mt-4 ms-2"
          color="grey darken-2 "
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('excel') }}
          </p>
          <v-icon>
            mdi-file-excel-outline
          </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('filter') }}
        </p>
        <v-icon>
          mdi-filter-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && $route.name !== 'sellTaxPayer' && $store.state.permissions && $store.state.permissions.includes(type)"
        outlined
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="px-2"
        :class="{ 'mb-4': !isMobile && !isTablet, 'mb-2': isMobile || isTablet}"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col
        v-show="!isMobile"
        class="pa-0"
        cols="12"
        md="12"
      >
        <v-chip-group
          mandatory
          active-class="primary--text"
        >
          <v-chip
            label
            outlined
          >
            {{ $t('sumNetAmount') }} : {{ $numberFormat((summary ? summary.amount : 0)) }} {{ $store.state.currency.name }}
          </v-chip>
          <v-chip
            label
            outlined
          >
            {{ $t('sumDiscount') }} : {{ $numberFormat((summary ? summary.discount : 0)) }} {{ $store.state.currency.name }}
          </v-chip>
          <v-chip
            label
            outlined
          >
            {{ $t('sumTax') }} : {{ $numberFormat((summary ? summary.tax : 0)) }} {{ $store.state.currency.name }}
          </v-chip>
          <v-chip
            label
            outlined
          >
            {{ $t('sumClearAmount') }} : {{ $numberFormat((summary ? summary.net_amount : 0)) }} {{ $store.state.currency.name }}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :page.sync="page"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template
          v-if="isMobile"
          v-slot:item="{ item, index }"
        >
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0 "
                :class="{
                  'mobile-td-list-border-green': (item.type == 'sell' || item.type == 'presale'? true : false ),
                  'mobile-td-list-border-red': (item.type == 'purchase' ? true : false ),
                  'mobile-td-list-border-primary': (item.type == 'returnSell' || item.type == 'returnPurchase' ? true : false ),
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          v-show="!item.taxpayer"
                          link
                          :disabled="(item.lock ? true : false)"
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="print(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('print')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="fishPrint(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-paper-roll-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceRollprint')" />
                        </v-list-item>
                        <v-list-item
                          v-if="type == 'sell'"
                          link
                          @click="invoiceSms(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-message-text-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('sendInvoiceSMS')" />
                        </v-list-item>
                        <v-list-item
                          v-if="item.entrepot"
                          link
                          @click="entrepotPrint(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-warehouse</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="copyInvoice(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-content-copy</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceCopy')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/' + type +'/edit/' + item.uid"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item
                          v-show="removePermission(type) && !item.tax_payer"
                          link
                          :disabled="(item.lock ? true : false)"
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink">
                              mdi-trash-can-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ (item.customer ? item.customer.name : '') }} ({{ item.number }})
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('document-number') }} : {{ (item.doc_header ? item.doc_header.number : '') }}
                    | {{ $t('id') }} : {{ item.id }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('discount') }} : {{ $numberFormat((item.discount ? item.discount : 0)) }}
                    | {{ $t('tax') }} : {{ $numberFormat((item.tax ? item.tax : 0)) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('date') }} : {{ item.date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px;margin-right:1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-for="(integrate, index) in item.integrator"
                        :key="index"
                        color="green"
                        label
                        small
                        style="margin-left: 1px;margin-right:1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ $t('registerBy') }} : {{ $t(integrate.key) }}  | {{ $t('id') }} : {{ integrate.value }}
                          {{ (integrate.number ? ' | ' + $t('number') + ':' + integrate.number : '' ) }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-if="item.payed"
                        class="ms-1"
                        :color="(parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? 'red' : 'green')"
                        small
                        outlined
                      >
                        {{ (parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? $t('remainPrice') + ' ' + $numberFormat(parseFloat(item.price.price)-parseFloat(item.payed.amount)) : $t('payed')) }}
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn
                    dark
                    text
                    small
                    color="primary"
                    @click="edit(item)"
                  >
                    {{ $numberFormat((item.price ? item.price.NetPrice : 0)) }} {{ item.currency ? item.currency.symbol : '' }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.action="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-show="!item.tax_payer"
                link
                :disabled="(item.lock ? true : false)"
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="lockPermission"
                link
                @click="lock(item, (item.lock ? 'unlock' : 'lock'))"
              >
                <v-list-item-icon>
                  <v-icon :color="(item.lock ? 'green' : 'pink')">
                    {{ (item.lock ? 'mdi-lock-open-outline' : 'mdi-lock-outline') }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="(item.lock ? $t('unlock') : $t('lock'))" />
              </v-list-item>
              <v-list-item
                v-show="type == 'sell' || type == 'presale'"
                link
                @click="editCategory(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('editCasher')" />
              </v-list-item>
              <v-list-item
                link
                @click="print(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                link
                @click="selectedPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-format-list-group</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print') + '(' + $t('new') + ')'" />
              </v-list-item>
              <v-list-item
                link
                @click="fishPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-paper-roll-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceRollprint')" />
              </v-list-item>
              <v-list-item
                v-if="!documentPermmission && item.attachments && item.attachments.length > 0"
                link
                @click="openDocumentsDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-attachment</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('documents')" />
              </v-list-item>
              <v-list-item
                v-if="type == 'sell' || type == 'presale'"
                link
                @click="invoiceSms(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-message-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('sendInvoiceSMS')" />
              </v-list-item>
              <v-list-item
                v-if="item.entrepot"
                link
                @click="entrepotPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-warehouse</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                link
                @click="copyInvoice(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceCopy')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + type +'/edit/' + item.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item
                v-show="item.tax_payer && item.tax_payer.taxid && item.tax_payer.status == 'done'"
                link
                :disabled="(item.lock ? true : false)"
                @click="editTaxInvoice(item)"
              >
                <v-list-item-icon>
                  <v-icon color="primary">
                    mdi-note-edit-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('sendEditTaxInvoice')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission(type) && (!item.tax_payer || item.tax_payer && item.tax_payer.taxid)"
                link
                :disabled="(item.lock ? true : false)"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-close-circle-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('annulmentInvoice')" />
              </v-list-item>
              <v-list-item
                v-show="removePermission(type) && (!item.tax_payer || item.tax_payer && !item.tax_payer.taxid)"
                link
                :disabled="(item.lock ? true : false)"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.row="{ item }">
          {{ parseInt(items.indexOf(item))+ parseInt(from) }}
        </template>
        <template v-slot:item.id="{ item }">
          <div>
            <a @click="edit(item)">
              {{ item.number != null ? item.number : $t('haveNot') }} {{ (item.official_number ? '(' + item.official_number + ')' : '') }}
            </a>
            <v-chip
              v-if="type === 'removedInvoices'"
              :color="(item.type === 'purchase' || item.type === 'returnPurchase' ? 'blue' : 'green')"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ $t(item.type) }}
              </span>
            </v-chip>
          </div>
          <div>
            <v-card-text class="pa-0 text-caption text-disable secondary--text">
              #{{ item.id != null ? item.id : $t('haveNot') }}
            </v-card-text>
            <v-icon
              v-if="item.lock"
              color="red"
              style="font-size: 22px"
            >
              mdi-lock-outline
            </v-icon>
          </div>
        </template>
        <template v-slot:item.doc_header.number="{ item }">
          <a
            v-if="item.doc_header"
            @click="openComponent('accountingPrint', item.doc_head_id)"
            class="text-disable secondary--text"
          >
            {{ item.doc_header.number }}
          </a>
          <v-card-text
            v-else
            class="pa-0 text-caption text-disable secondary--text">
            {{ $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.customer.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-1"
              @click="openComponent('account', item.customer_id)"
            >
              {{ (item.customer ? item.customer.name : $t('haveNot')) }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.customer"
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.customer.fin_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('turnover') }}</span>
            </v-tooltip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.customer && item.customer.mobile != null && item.customer.mobile != '' ? item.customer.mobile : $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.date="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.date ? item.date : $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat((item.price ? item.price.price : 0), (item.currency ? item.currency.decimal : 0)) }} {{ item.currency ? item.currency.symbol : '' }}
          <div class="d-flex align-center gap-1" v-if="item.discount != 0">
            <v-card-text class="pa-0 text-caption text-disable secondary--text">{{ $t('discount') }}:</v-card-text>
            <v-card-text class="pa-0 text-caption">{{ $numberFormat((item.discount ? item.discount : 0)) }}</v-card-text>
          </div>
          <div class="d-flex align-center gap-1" v-if="item.tax != 0">
            <v-card-text class="pa-0 text-caption text-disable secondary--text">{{ $t('tax') }}:</v-card-text>
            <v-card-text class="pa-0 text-caption">{{ $numberFormat((item.tax ? item.tax : 0)) }}</v-card-text>
          </div>
        </template>
        <template v-slot:item.payed.amount="{ item }">
          <v-card-text class="pa-0 text-body-2" v-if="item.payed != null && item.payed.amount != 0">
            {{ $numberFormat((item.payed ? item.payed.amount : 0), (item.currency ? item.currency.decimal : 0)) }} {{ item.currency ? item.currency.symbol : '' }}
          </v-card-text>
          <div class="d-flex align-center gap-1" v-if="item.payed != null && item.payed.paymentsAmount != 0">
            <v-card-text class="pa-0 text-caption text-disable secondary--text">نقد:</v-card-text>
            <v-card-text class="pa-0 text-caption">
              {{ $numberFormat((item.payed ? item.payed.paymentsAmount : 0), (item.currency ? item.currency.decimal : 0)) }} {{ item.currency ? item.currency.symbol : '' }}
            </v-card-text>
          </div>
          <div class="d-flex align-center gap-1" v-if="item.payed != null && item.payed.checksAmount != 0">
            <v-card-text class="pa-0 text-caption text-disable secondary--text">{{ $t('check') }}:</v-card-text>
            <v-card-text class="pa-0 text-caption">
              {{ $numberFormat((item.payed ? item.payed.checksAmount : 0), (item.currency ? item.currency.decimal : 0)) }} {{ item.currency ? item.currency.symbol : '' }}
            </v-card-text>
          </div>
          <v-chip
            v-if="item.payed != null"
            class="mx-0"
            :color="(parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? 'red' : 'green')"
            small
            outlined
          >
            {{ (parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? $t('remainPrice') + ' ' + $numberFormat(parseFloat(item.price.price)-parseFloat(item.payed.amount)) : $t('payed')) }}
          </v-chip>
          <v-card-text
            v-if="item.payed == null"
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.pre_invoice="{ item }">
          <v-icon
            v-if="item.pre_invoice == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">ندارد</v-card-text>
        </template>
        <template v-slot:item.entrepot.id="{ item }">
          <v-btn
            v-if="item.entrepot"
            :loading="loading"
            class="ma-0 pa-1 text-right"
            :color="(item.entrepot.type === 'remittance' ? 'pink' : (item.entrepot.type === 'receipt' ? 'teal' : 'blue'))"
            plain
            small
            @click="entrepot_(item.entrepot)"
          >
            {{ $t(item.entrepot.type) }} {{ $t('entrepot') }} {{ (item.entrepot && item.entrepot.entrepot ? item.entrepot.entrepot.name : '') }}
            <br />
            {{ item.entrepot.id }}
          </v-btn>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{ $t('haveNot') }}</v-card-text>
        </template>
        <template v-slot:item.branch.name="{ item }">
          <v-card-text class="pa-0 text-caption" v-if="item.branch">
            {{ item.branch.name }}
          </v-card-text>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
            {{ $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ (item.last_status ? item.last_status.status.name : '') }}
            </span>
          </v-chip>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{ $t('haveNot') }}</v-card-text>
        </template>
        <template v-slot:item.tags="{ item }">
          <v-container
            v-if="item.tags.length > 0"
            class="pa-0 d-flex gap-1"
            style="flex-wrap: wrap;max-width: 165px !important;min-width: 120px;"
          >
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              @click="edit(item)"
              label
              small
              class="px-1 mb-1"
              style="background: transparent;border: 1px solid #959494;border-radius: 10px !important;"
            >
              <span class="px-1">
                {{ tag.text }}
              </span>
            </v-chip>
          </v-container>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{ $t('haveNot') }}</v-card-text>
        </template>
        <template v-slot:item.taxid="{ item }">
          <v-card-text class="pa-0 text-caption">{{ (item.tax_payer && item.tax_payer.taxid ? $t('sendTaxid') + ':' + item.tax_payer.taxid : '') }}</v-card-text>
          <v-card-text class="pa-0 text-caption">{{ (item.tax_payer && item.tax_payer.edit_taxid ? $t('editTaxid') + ':' + item.tax_payer.edit_taxid : '') }}</v-card-text>
          <v-card-text class="pa-0 text-caption">{{ (item.tax_payer && item.tax_payer.remove_taxid ? $t('removeTaxid') + ':' + item.tax_payer.remove_taxid : '') }}</v-card-text>
          <tax-payer-content
            :invoice-prop="item"
          />
          <v-card-text
            v-if="item.tax_payer == null || (item.tax_payer && item.tax_payer.taxid == null && item.tax_payer.edit_taxid == null && item.tax_payer.remove_taxid == null && item.tax_payer.status == null)"
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t('haveNot') }}
          </v-card-text>
        </template>
        <template v-slot:item.content="{ item }">
          <v-card-text
            v-if="
            (item.integrator.length == 0)||
            (item.integrator.length != 0 && !item.integrator.find(item => item.key == 'woocommerceInvoice')
            && item.integrator.length != 0 && !item.integrator.find(item => item.key == 'digikalaInvoice')
            && item.integrator.length != 0 && !item.integrator.find(item => item.key == 'sazitoInvoice')
            && item.integrator.length != 0 && !item.integrator.find(item => item.key == 'webziInvoice')
            && item.integrator.length != 0 && !item.integrator.find(item => item.key == 'portalInvoice')
            && item.content == null
            && item.custom_fields.length == 0)
            "
            class="pa-0 text-caption text-disable secondary--text"
          >
          {{ $t('haveNot') }}
          </v-card-text>
          <!--woocommerce id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'woocommerceInvoice') && item.integrator.find(item => item.key == 'woocommerceInvoice').value != null"
          >
            <img src="@/assets/woo.png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('id') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'woocommerceInvoice') && item.integrator.find(item => item.key == 'woocommerceInvoice').value != null"
              v-clipboard:copy="item.integrator.find(item => item.key == 'woocommerceInvoice').value"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.find(item => item.key == 'woocommerceInvoice').value }}
            </v-card-text>
          </v-container>
          <!--digikala id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'digikalaInvoice') && item.integrator.find(item => item.key == 'digikalaInvoice').value != null"
          >
            <img src="@/assets/digikala.png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('id') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'digikalaInvoice') && item.integrator.find(item => item.key == 'digikalaInvoice').value != null"
              v-clipboard:copy="item.integrator.find(item => item.key == 'digikalaId').value"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.find(item => item.key == 'digikalaInvoice').value }}
            </v-card-text>
          </v-container>
          <!--sazito id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'sazitoInvoice') && item.integrator.find(item => item.key == 'sazitoInvoice').value != null"
          >
            <img src="@/assets/sazito(1).png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('id') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'sazitoInvoice') && item.integrator.find(item => item.key == 'sazitoInvoice').value != null"
              v-clipboard:copy="item.integrator.find(item => item.key == 'sazitoInvoice').value"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.find(item => item.key == 'sazitoInvoice').value }}
            </v-card-text>
          </v-container>
          <!--webzi id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'webziInvoice') && item.integrator.find(item => item.key == 'webziInvoice').value != null"
          >
            <img src="@/assets/webzi.png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('id') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'webziInvoice') && item.integrator.find(item => item.key == 'webziInvoice').value != null"
              v-clipboard:copy="item.integrator.find(item => item.key == 'webziInvoice').value"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.find(item => item.key == 'webziInvoice').value }}
            </v-card-text>
          </v-container>
          <!--markito id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'markitoInvoice') && item.integrator.find(item => item.key == 'markitoInvoice').value != null"
          >
            <img src="@/assets/markito.png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('id') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'markitoInvoice') && item.integrator.find(item => item.key == 'markitoInvoice').value != null"
              v-clipboard:copy="item.integrator.find(item => item.key == 'markitoInvoice').value"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.find(item => item.key == 'markitoInvoice').value }}
            </v-card-text>
          </v-container>
          <!--portal id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'portalInvoice') && item.integrator.find(item => item.key == 'portalInvoice').value != null"
          >
            <img src="@/assets/portal.png" style="width: 15px;height: 15px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('id') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator.length > 0 && item.integrator.find(item => item.key == 'portalInvoice') && item.integrator.find(item => item.key == 'portalInvoice').value != null"
              v-clipboard:copy="item.integrator.find(item => item.key == 'portalInvoice').value"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.find(item => item.key == 'portalInvoice').value }}
            </v-card-text>
          </v-container>
          <!--custom filds-->
          <div
            v-if="item.custom_fields"
            class="pt-1"
          >
            <v-chip
              v-for="(field, index) in item.custom_fields"
              :key="index"
              label
              color="primary"
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ field.key }} : {{ field.value }}
              </span>
            </v-chip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ (item.content ? item.content.substr(0, (item.deleted_at ? item.content.length : 20)) : '') }} {{ (!item.deleted_at && item.content && item.content.length > 20 ? '...' : '') }}
          </v-card-text>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-card-text class="pa-0 text-caption">
                  {{ item.user.firstname }}  {{ item.user.lastname }}
                </v-card-text>
              </div>
              <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{ $t('haveNot') }}</v-card-text>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>


        <!-- <template v-slot:item.price.NetPrice="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ $numberFormat((item.price ? item.price.NetPrice : 0)) }} {{ item.currency.symbol }}
          </v-card-text>
        </template>
        <template v-slot:item.plan="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.plan"
              color="primary"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ (item.plan ? item.plan.plan.name : '') }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>-->
        <template
          v-slot:body.append
        >
          <tr>
            <td
              :colspan="`${isMobile?6:Number(showHeaders.length)}`"
            >
              <div
                style="width: 100%;"
                class="pa-1"
              >
                <strong>{{ $t('sumInPage') }}</strong>:
                <v-chip
                  color="pOrrange"
                  class="px-1 me-1"
                  outlined
                >
                  <span
                    class="px-1"
                    style="font-size: 11px"
                  >
                    {{ $t('netAmount') }}:{{ $numberFormat(totals.price.toFixed($store.state.currency.decimal)) }}
                  </span>
                </v-chip>
                <v-chip
                  color="pink"
                  class="px-1 me-1"
                  outlined
                >
                  <span
                    class="px-1"
                    style="font-size: 11px"
                  >
                    {{ $t('discount') }}:{{ $numberFormat(totals.discount.toFixed($store.state.currency.decimal)) }}
                  </span>
                </v-chip>
                <v-chip
                  color="secondary"
                  class="px-1 me-1"
                  outlined
                >
                  <span
                    class="px-1"
                    style="font-size: 11px"
                  >
                    {{ $t('tax') }}:{{ $numberFormat(totals.tax.toFixed($store.state.currency.decimal)) }}
                  </span>
                </v-chip>
                <v-chip
                  color="primary"
                  class="px-1 me-1"
                >
                  <span
                    class="px-1 white--text"
                    style="font-size: 11px"
                  >
                    {{ $t('clearAmount') }}:{{ $numberFormat(totals.sumNetAmount.toFixed($store.state.currency.decimal)) }}
                  </span>
                </v-chip>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="invoicePrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="invoicePrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint
            :id-prop="printId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
      :draggable="true"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="account"
              :title="$t('customer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="category"
              :title="$t('category')"
              type="accountCategory"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="lockStatus"
              :label="$t('lockStatusDocuments')"
              :items="lockStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="!isMobile && customFieldsPermission"
          class="mx-0"
        >
          <custom-fields
            v-model="customFields"
            :value="customFields"
            type-prop="invoiceCustomFields"
            :multiple="true"
            class="px-4"
          />
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="invoice"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="documentsDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="documentsDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <div
          align="center"
          class="px-4"
        >
          <v-btn
            color="primary"
            block
            elevation="0"
            style="font-size: 16px"
          >
            {{ documentsTitleDialog }}
          </v-btn>
        </div>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <file-picker
            ref="refFilePicker"
            :label="$t('addDocuments')"
            :multiple="false"
            :hide-remove="true"
            type-prop="invoice"
            :val="(documents ? documents : null)"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="groupPrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="40%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="groupPrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col class="text-right">
            <v-radio-group v-model="printType">
              <v-radio value="officialInvoice">
                <template v-slot:label>
                  <div>{{ $t('officialInvoice') }}</div>
                </template>
              </v-radio>
              <v-radio value="invoice">
                <template v-slot:label>
                  <div>{{ $t('generalInvoice') }}</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn
            color="primary"
            :loading="loading"
            @click="groupPrintInvoice"
          >
            {{ $t('print') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="grey"
            @click="groupPrintDialog = !groupPrintDialog"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Invoicprint from './print'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  import filePicker from '../../components/general/filePicker/index'
  import TaxPayerContent from './taxPayerContent.vue'
  import customFields from '../../components/general/customFields/index.vue'
  export default {
    name: 'InvoiceList',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Upload,
      customFields,
      filePicker,
      TaxPayerContent,
      Invoicprint,
      Task,
    },
    mixins: [General],
    props: ['input', 'refId', 'typeProp', 'accountProp', 'mobileShow'],
    data: () => ({
      selected: [],
      printHeaders: [],
      datatableStore: false,
      summary: null,
      registerar: null,
      removedInvoices: null,
      groupPrintDialog: false,
      invoicePrintDialog: false,
      printDialog: false,
      deletDialog: false,
      uploadDialog: false,
      documentsDialog: false,
      documents: false,
      documentsTitleDialog: '',
      printType: 'invoice',
      dialogData: null,
      entrepot: null,
      category: null,
      account: null,
      currencyFilter: null,
      fromAmount: null,
      toAmount: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      printId: null,
      showSelect: true,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      customFields: null,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      selectedHeadersTemp: [],
      headersMap: null,
      pageCount: 1,
      page: 1,
      excelItems: [],
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        // var total = this.items.map(function (value, key) {
        //   app.remove(value, key)
        // })
        // var app = this
        // app.excelItems = []
        const totals = this.items.reduce((acc, d) => {
          acc.price += (d.price ? parseFloat(d.price.price) + parseFloat((d.discount ? d.discount : 0)) - parseFloat((d.tax ? d.tax : 0)) : 0)
          acc.sumNetAmount += (d.price ? parseFloat(d.price.price) : 0)
          acc.discount += parseFloat(d.discount)
          acc.tax += parseFloat(d.tax)
          return acc
        }, {
          sumNetAmount: 0,
          price: 0,
          discount: 0,
          tax: 0,
        })
        return totals
      },
    },
    watch: {
      selectedHeaders (val) {
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        app.getItems()
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      accountProp (val) {
        this.getItems()
      },
    },
    activated () {
      // this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'purchaseList') {
        this.type = 'purchase'
      }
      if (this.$route.name === 'presaleList') {
        this.type = 'presale'
      }
      if (this.$route.name === 'sellList') {
        this.type = 'sell'
      }
      if (this.$route.name === 'returnPurchaseList') {
        this.type = 'returnPurchase'
      }
      if (this.$route.name === 'returnSellList') {
        this.type = 'returnSell'
      }
      if (this.$route.name === 'sellTaxPayer') {
        this.type = 'sell'
      }
      if (this.$route.name === 'removedInvoices') {
        this.type = 'removedInvoices'
        this.removedInvoices = 'active'
      }
      if (this.typeProp) {
        this.type = this.typeProp
      }
      this.headers = [
        {
          text: this.$t('action'),
          align: 'start',
          sortable: false,
          value: 'action',
          width: 20,
        },
        {
          text: this.$t('#'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'invoice_header.id',
          width: 80,
        },
/*         {
          text: this.$t('number'),
          sortable: true,
          value: 'number',
          table: 'invoice_header.number',
          width: 70,
        }, */
        {
          text: this.$t('number') + ' ' + this.$t('document'),
          sortable: false,
          value: 'doc_header.number',
          width: 70,
        },
        {
          text: this.$t('detailsName'),
          sortable: false,
          value: 'customer.name',
          width: 150,
        },
/*         {
          text: this.$t('mobile'),
          sortable: false,
          value: 'customer.mobile',
          width: 100,
        }, */
        {
          text: this.$t('date'),
          sortable: true,
          value: 'date',
          table: 'invoice_header.date',
          width: 70,
        },
/*         {
          text: this.$t('NetAmount'),
          sortable: false,
          value: 'price.NetPrice',
          width: 100,
        }, */
/*         {
          text: this.$t('discount'),
          sortable: false,
          value: 'discount',
          width: 90,
        },
        {
          text: this.$t('tax'),
          sortable: false,
          value: 'tax',
          width: 80,
        }, */
        {
          text: this.$t('finalAmount'),
          sortable: false,
          value: 'price.price',
          width: 100,
        },
/*         {
          text: this.$t('sumPayments'),
          sortable: false,
          value: 'payed.paymentsAmount',
          width: 100,
        },
        {
          text: this.$t('sumChecks'),
          sortable: false,
          value: 'payed.checksAmount',
          width: 100,
        }, */
        {
          text: this.$t('sumPayed'),
          sortable: false,
          value: 'payed.amount',
          width: 100,
        },
        {
          text: this.$t('preInvoice'),
          sortable: false,
          value: 'pre_invoice',
          table: 'doc_header.pre_invoice',
          width: 50,
        },
        {
          text: this.$t('entrepot'),
          sortable: false,
          value: 'entrepot.id',
          width: 70,
        },
        {
          text: this.$t('branch'),
          sortable: false,
          value: 'branch.name',
          width: 100,
        },
        {
          text: this.$t('status'),
          sortable: false,
          value: 'last_status.status_id',
          table: 'doc_header.buyer_id',
          width: 90,
        },
        // {
        //   text: this.$t('plan'),
        //   sortable: false,
        //   value: 'plan',
        // },
        {
          text: this.$t('tag'),
          sortable: false,
          value: 'tags',
          width: 150,
        },
        {
          text: this.$t('taxId'),
          sortable: false,
          value: 'taxid',
          width: 150,
        },
        {
          text: this.$t('other'),
          sortable: false,
          value: 'content',
          table: 'products.description',
          width: 200,
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
          width: 100,
        },
      ]
      this.printHeaders = [
        {
          text: this.$t('id'),
          value: 'id',
        },
        {
          text: this.$t('number'),
          value: 'number',
        },
        {
          text: this.$t('detailsName'),
          value: 'customer.name',
        },
        {
          text: this.$t('mobile'),
          value: 'customer.mobile',
        },
        {
          text: this.$t('date'),
          value: 'date',
        },
        {
          text: this.$t('NetAmount'),
          value: 'price.NetPrice',
        },
        {
          text: this.$t('discount'),
          value: 'discount',
          sum: true,
          type: 'number'
        },
        {
          text: this.$t('tax'),
          value: 'tax',
          sum: true,
          type: 'number'
        },
        {
          text: this.$t('finalAmount'),
          value: 'price.price',
          sum: true,
          type: 'number'
        },
        {
          text: this.$t('sumPayments'),
          value: 'payed.paymentsAmount',
          sum: true,
          type: 'number'
        },
        {
          text: this.$t('sumChecks'),
          value: 'payed.checksAmount',
          sum: true,
          type: 'number'
        },
        {
          text: this.$t('sumPayed'),
          value: 'payed.amount',
          sum: true,
          type: 'number'
        },
      ];

      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      // this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
      this.getPermissions()
    },
    methods: {
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          const tags = d.tags.map(item => item.text).join(',')
          app.excelItems.push({
            id: d.id,
            type: app.$t(d.type),
            number: d.number,
            customer: (d.customer ? d.customer.name : null),
            mobile: (d.customer ? d.customer.mobile : null),
            date: d.date,
            price: app.$numberFormat((d.price ? d.price.price : 0)),
            discount: app.$numberFormat(d.discount),
            tax: app.$numberFormat(d.tax),
            warehouse: (d.entrepot ? d.entrepot.entrepot.name : ''),
            payment: (d.payed ? app.$numberFormat(d.payed.amount) : ''),
            content: d.content,
            tags: (d.tags ? tags : null),
            integrator: (d.integrator && d.integrator.length > 0 ? app.$t(d.integrator[0].key) + ' = ' + d.integrator[0].value + ' | ' + d.integrator[0].number : ''),
            user: (d.user ? d.user.name : ''),
          })
        })
      },
      lock (item, type) {
        this.selected = [item]
        this.lockGroup(type)
      },
      lockGroup (type) {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            lock: 'active',
            id: selected,
            type: type,
          },
        })
          .then(res => {
            res = res.data
            app.snakbarText = this.$t('opertationSuccess')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.getItems()
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(function () {
            app.loading = false
            app.selected = []
          })
      },
      reviewDigikalaOrder () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            reviewDigikalaOrder: 'active',
            items: selected,
          },
        })
          .then(res => {
            res = res.data
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      refreshRemovedItem () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            refreshRemovedInvoices: 'active',
            items: selected,
          },
        })
          .then(res => {
            res = res.data
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      openDocumentsDialog (item) {
        this.documentsTitleDialog = this.$t('documents') + ' ' + this.$t(item.type) + ' ' + item.number
        this.documents = item.attachments
        this.documentsDialog = true
      },
      copyInvoice (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice/' + item.uid + '/edit', {
          params: {
            id: item.uid,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: app.type, params: { itemsProp: res.article } })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      entrepot_ (item) {
        this.$router.push({ name: item.type + 'Edit', params: { id: item.id } })
      },
      openComponent (component, id) {
        if(this.$store.state.permissions.includes('customerEdit')) {
          this.dialogData = {
            name: component,
            id: id,
          }
          this.innerComponent = true
        }
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        if (item.lock) {
          return false
        }
        if (!this.removedInvoices) {
          this.$router.push({ name: this.type + 'Edit', params: { id: item.uid, tabName: item.number } })
        }
      },
      editCategory (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: 'invoiceCasherEdit', params: { id: item.uid, tabName: item.number } })
        }
      },
      print (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: 'invoicePrint', params: { id: item.uid, tabName: item.number } })
        }
        // this.printId = item.uid
        // this.invoicePrintDialog = true
      },
      fishPrint (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: 'invoiceRollprint', params: { id: item.uid, tabName: item.number } })
        }
      },
      entrepotPrint (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: item.entrepot.type + 'Print', params: { id: item.entrepot.id } })
        }
      },
      getItems () {
        var app = this
        app.filter = false
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'invoice', {
            params: {
              search: app.search,
              accountProp: (app.accountProp ? app.accountProp.id : null),
              account: app.account,
              fromDate: app.fromDate,
              toDate: app.toDate,
              fromAmount: app.fromAmount,
              category: app.category,
              toAmount: app.toAmount,
              fromNumber: app.fromNumber,
              toNumber: app.toNumber,
              currency: app.currencyFilter,
              entrepot: app.entrepot,
              branch: app.branch,
              page: (app.allRows ? app.excelPage : app.options.page),
              refId: app.refId,
              type: app.type,
              sortBy: app.sortBy,
              customFields: app.customFields,
              status: app.sellStatus,
              options: app.options,
              tag: app.tag,
              typeForm: app.typeForm,
              registerar: app.registerar,
              lockStatus: app.lockStatus,
              removedInvoices: app.removedInvoices,
              taxpayer: (app.$route.name === 'sellTaxPayer' ? 'active' : null),
            },
          })
            .then(res => {
              res = res.data
              if (!app.allRows) {
                app.items = res.data
                app.totalItems = res.total
                app.pageCount = res.last_page
                app.from = res.from
                app.summary = res.summary
                app.creatExcelData(res.data)
                app.selected = []
              } else {
                app.generateExcellForAllData(res.data, res.last_page)
              }
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.loading = false))
        }, 500)
      },
      invoiceSms (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            invoiceSMS: 'active',
            id: item.id,
          },
        })
          .then(res => {
            res = res.data
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('sent')
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      sendTaxInvoice (type = null) {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            sendTaxInvoice: 'active',
            type: type,
            items: selected,
          },
        })
          .then(res => {
            res = res.data
            if (!type) {
              app.snakbarColor = 'green'
              app.snakbarText = this.$t('sent')
              app.snakbar = true
            } else {
              app.getItems()
            }
            app.selected = []
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      editTaxInvoice (item) {
        var app = this
        app.loading = true
        var selected = [item.id]
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            editTaxInvoice: 'active',
            items: selected,
          },
        })
          .then(res => {
            res = res.data
            // if (!type) {
            //   app.snakbarColor = 'green'
            //   app.snakbarText = this.$t('sent')
            //   app.snakbar = true
            // } else {
            app.getItems()
            // }
            app.selected = []
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      selectedPrint (item) {
        this.selected = [item]
        this.groupPrintDialog = true
      },
      groupPrintInvoice () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            groupPrint: 'active',
            items: selected,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: 'reportViewer', params: { dataProp: res, reportProp: app.printType } })
            app.selected = []
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.deleteItem = null
            app.loading = false
          })
      },
      removegroup () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.deleteItem = null
            app.selected = []
            app.loading = false
          })
      },
      getPermissions () {
        var app = this
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'getPermissions',
          },
        })
        .then(res => {
          res = res.data
          app.$store.commit('SET_PERMISSIONS', res.permissions)
        })
      }
    },
  }
</script>

<style scoped>
::v-deep .v-slide-group__next,
::v-deep .v-slide-group__prev {
  justify-content: inherit;
  min-width: unset;
}
::v-deep .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd),
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
    /* background-color: transparent !important; */
    height: 60px;
}
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  height: 48px;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd),
  ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
    height: auto;
  }
}
</style>
